import useTrans from '@hooks/useTrans'
import { Breadcrumbs, WContainer } from '@components/atoms'
import HeaderBrand, { BrandType } from '@components/molecules/HeaderBrand/HeaderBrand'
import styles from './CollezioneHead.module.sass'

interface Props {
  collezione: any // TODO: CollezioneNode
  className?: string
}

const CollezioneHead = (props: Props) => {
  const { collezione = undefined, className = '' } = props

  const t = useTrans()

  return (
    <div className={`${styles.root} ${className}`}>
      <HeaderBrand brand={collezione.brand?.slug as BrandType} />
      <WContainer className={styles.container}>
        <Breadcrumbs className={styles.breadcrumbs} breadcrumbs={collezione.breadcrumbs} />
        <div className={styles.content}>
          <h1 className={styles.title}>{collezione.title}</h1>
          <p
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: t('By {0}', [`<strong>${collezione.brand.nome}</strong>`]),
            }}
          />
        </div>
      </WContainer>
    </div>
  )
}

export default CollezioneHead
